import { extractValues } from '../../_util';
import { NEW_NON_EMPLOYEE_KEYS } from '../../_const';
import { NEW_NON_EMPLOYEE_CONFIG } from '../../_config';

/**
 * Cherry-picked configuration for the Community Connect User type
 */
const COMMUNITY_CONNECT_CONFIG = {
	[NEW_NON_EMPLOYEE_KEYS.ACKNOWLEDGEMENT]: {
		...NEW_NON_EMPLOYEE_CONFIG[NEW_NON_EMPLOYEE_KEYS.ACKNOWLEDGEMENT],
	},
	[NEW_NON_EMPLOYEE_KEYS.ALTERNATE_EMAIL]: {
		...NEW_NON_EMPLOYEE_CONFIG[NEW_NON_EMPLOYEE_KEYS.ALTERNATE_EMAIL],
	},
	[NEW_NON_EMPLOYEE_KEYS.DATE_OF_BIRTH]: {
		...NEW_NON_EMPLOYEE_CONFIG[NEW_NON_EMPLOYEE_KEYS.DATE_OF_BIRTH],
	},
	[NEW_NON_EMPLOYEE_KEYS.FIRST_NAME]: {
		...NEW_NON_EMPLOYEE_CONFIG[NEW_NON_EMPLOYEE_KEYS.FIRST_NAME],
	},
	[NEW_NON_EMPLOYEE_KEYS.DUPLICATE_ID_CHECK]: {
		...NEW_NON_EMPLOYEE_CONFIG[NEW_NON_EMPLOYEE_KEYS.DUPLICATE_ID_CHECK],
	},
	[NEW_NON_EMPLOYEE_KEYS.IDENTIFIER_NUMBER]: {
		...NEW_NON_EMPLOYEE_CONFIG[NEW_NON_EMPLOYEE_KEYS.IDENTIFIER_NUMBER],
	},
	[NEW_NON_EMPLOYEE_KEYS.IDENTIFIER_TYPE]: {
		...NEW_NON_EMPLOYEE_CONFIG[NEW_NON_EMPLOYEE_KEYS.IDENTIFIER_TYPE],
	},
	[NEW_NON_EMPLOYEE_KEYS.IDENTIFIER_SPECIFIER]: {
		...NEW_NON_EMPLOYEE_CONFIG[NEW_NON_EMPLOYEE_KEYS.IDENTIFIER_SPECIFIER],
	},
	[NEW_NON_EMPLOYEE_KEYS.IS_SITE_ADMIN]: {
		...NEW_NON_EMPLOYEE_CONFIG[NEW_NON_EMPLOYEE_KEYS.IS_SITE_ADMIN],
	},
	[NEW_NON_EMPLOYEE_KEYS.JOB_TITLE]: {
		...NEW_NON_EMPLOYEE_CONFIG[NEW_NON_EMPLOYEE_KEYS.JOB_TITLE],
	},
	[NEW_NON_EMPLOYEE_KEYS.LAST_NAME]: {
		...NEW_NON_EMPLOYEE_CONFIG[NEW_NON_EMPLOYEE_KEYS.LAST_NAME],
	},
	[NEW_NON_EMPLOYEE_KEYS.MIDDLE_INITIAL]: {
		...NEW_NON_EMPLOYEE_CONFIG[NEW_NON_EMPLOYEE_KEYS.MIDDLE_INITIAL],
	},
	[NEW_NON_EMPLOYEE_KEYS.NOT_A_DUPLICATE_ACKNOWLEDGEMENT]: {
		...NEW_NON_EMPLOYEE_CONFIG[
			NEW_NON_EMPLOYEE_KEYS.NOT_A_DUPLICATE_ACKNOWLEDGEMENT
		],
	},
	[NEW_NON_EMPLOYEE_KEYS.NOT_A_DUPLICATE_REASON]: {
		...NEW_NON_EMPLOYEE_CONFIG[
			NEW_NON_EMPLOYEE_KEYS.NOT_A_DUPLICATE_REASON
		],
	},
	[NEW_NON_EMPLOYEE_KEYS.PHONE_NUMBER]: {
		...NEW_NON_EMPLOYEE_CONFIG[NEW_NON_EMPLOYEE_KEYS.PHONE_NUMBER],
	},
	[NEW_NON_EMPLOYEE_KEYS.PHONE_NUMBER_EXTENSION]: {
		...NEW_NON_EMPLOYEE_CONFIG[
			NEW_NON_EMPLOYEE_KEYS.PHONE_NUMBER_EXTENSION
		],
	},
	[NEW_NON_EMPLOYEE_KEYS.PREREQUISITE_CHECK]: {
		...NEW_NON_EMPLOYEE_CONFIG[NEW_NON_EMPLOYEE_KEYS.PREREQUISITE_CHECK],
	},
	[NEW_NON_EMPLOYEE_KEYS.SELF_SPONSOR]: {
		...NEW_NON_EMPLOYEE_CONFIG[NEW_NON_EMPLOYEE_KEYS.SELF_SPONSOR],
	},
	[NEW_NON_EMPLOYEE_KEYS.SPONSOR]: {
		...NEW_NON_EMPLOYEE_CONFIG[NEW_NON_EMPLOYEE_KEYS.SPONSOR],
	},
	[NEW_NON_EMPLOYEE_KEYS.THIRD_PARTY_ORGANIZATION]: {
		...NEW_NON_EMPLOYEE_CONFIG[
			NEW_NON_EMPLOYEE_KEYS.THIRD_PARTY_ORGANIZATION
		],
	},
	[NEW_NON_EMPLOYEE_KEYS.WAVE_ONE_LOCATION]: {
		...NEW_NON_EMPLOYEE_CONFIG[NEW_NON_EMPLOYEE_KEYS.WAVE_ONE_LOCATION],
	},
};

const COMMUNITY_CONNECT_INITIAL_VALUES = extractValues(
	COMMUNITY_CONNECT_CONFIG,
	'initialValue',
	null
);
const extractedValidationSchema = extractValues(
	COMMUNITY_CONNECT_CONFIG,
	'validationSchema',
	null
);

/**
 * You can modify the schema in one of the following ways:
 * 1. Extend the schema for a particular field
 * @example
 * //you want to keep the default schema for PHONE_NUMBER, but now you want it required
 *   const COMMUNITY_CONNECT_INITIAL_VALIDATION_SCHEMA = {
        ...extractedValidationSchema,
        [NEW_NON_EMPLOYEE_KEYS.PHONE_NUMBER]: extractedValidationSchema[
            NEW_NON_EMPLOYEE_KEYS.PHONE_NUMBER
        ].concat(Yup.string().required('Phone Number is required.'))
    };

* 2. Overwrite the schema for a particular field
* @example
* //you want to write an entirely new schema for MIDDLE_INITIAL
* const COMMUNITY_CONNECT_INITIAL_VALIDATION_SCHEMA = {
    ...extractValues(COMMUNITY_CONNECT_CONFIG, 'validationSchema', null),
    [NEW_NON_EMPLOYEE_KEYS.MIDDLE_INITIAL]: Yup.string()
        .trim()
        .matches(
            /^[a-zA-Z]*$/,
            'The value provided contains invalid characters'
        )
        .maxCounter(1)
        .required('Middle Initial is required.'),	//THIS IS NEW
};
*/
const COMMUNITY_CONNECT_INITIAL_VALIDATION_SCHEMA = {
	...extractedValidationSchema,
};

const COMMUNITY_CONNECT_COMPONENTS = extractValues(
	COMMUNITY_CONNECT_CONFIG,
	'component',
	null
);

const COMMUNITY_CONNECT_USER = {
	name: 'Community Connect User',
	id: 92,
};

export {
	COMMUNITY_CONNECT_CONFIG,
	COMMUNITY_CONNECT_INITIAL_VALUES,
	COMMUNITY_CONNECT_INITIAL_VALIDATION_SCHEMA,
	COMMUNITY_CONNECT_COMPONENTS,
	COMMUNITY_CONNECT_USER,
};
